'use client'

import React, { useEffect, useState } from 'react'

import Spacer from 'lib/components/Spacer/Spacer'

import usePolicyDocumentApi from '@/api/usePolicyDocumentApi'
import SiteHeaderWrapper from '@/components/SiteHeaderWrapper'
import { brand } from '@/utils/brand'

import ShipplayPartnerAgreementTermsPage from './ShipplayPartnerAgreementTermsPage'

const PartnerAgreementTermsPage: React.FC = () => {
  return brand.key === 'shipplay' ? (
    <ShipplayPartnerAgreementTermsPage />
  ) : (
    <DefaultPartnerAgreementTermsPage />
  )
}

const DefaultPartnerAgreementTermsPage: React.FC = () => {
  const [content, setContent] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string>('')
  const { fetchPolicyDocument } = usePolicyDocumentApi()

  useEffect(() => {
    const loadPolicyDocument = async (): Promise<void> => {
      try {
        setLoading(true)
        const response = await fetchPolicyDocument(brand.key, 'Partner Agreement Terms')
        setContent(response.data.content)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load partner agreement terms')
      } finally {
        setLoading(false)
      }
    }

    loadPolicyDocument()
  }, [fetchPolicyDocument])

  if (loading) {
    return (
      <div className="bg-white">
        <SiteHeaderWrapper />
        <div className="mx-auto pt-32">
          <div className="mx-auto max-w-[1056px] px-6">
            <div className="flex items-center justify-center py-12">
              <div className="text-lg">Loading partner agreement terms...</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="bg-white">
        <SiteHeaderWrapper />
        <div className="mx-auto pt-32">
          <div className="mx-auto max-w-[1056px] px-6">
            <div className="flex items-center justify-center py-12">
              <div className="text-lg text-red-600">Error: {error}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white">
      <SiteHeaderWrapper />
      <div className="mx-auto pt-32 [&_p]:mt-6">
        <div className="mx-auto max-w-[1056px] px-6">
          <h2 className="mb-6 type-display-3 lg:type-headline-3">Partner Agreement Terms</h2>
          <div
            className="policy-content"
            style={{
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#333',
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
      <Spacer />
    </div>
  )
}

export default PartnerAgreementTermsPage
